<template>
  <div class="Block Block Block--stroke">
    <div v-show="incentive.result == 'incentive-available'">
      <h1 v-html="redeemTitle" />
      <p>Congratulations! You have successfully earned your &pound;5 Amazon voucher and can claim it by clicking the button below.</p>

      <div v-show="incentive.charities_count > 0">
        <p>Or, you can choose to donate your &pound;5 to one of our nominated charities listed below.</p>
        <table>
          <tr
            v-for="charity in incentive.charities"
            :key="charity.id"
            class="pointer"
            @click="selectCharity(charity)"
          >
            <td>
              <div class="Notice Notice--info">
                Donate to {{ charity.incentive_type_name }}
              </div>
            </td>
            <td
              style="background:none"
              class="Notice Notice-Copy"
            >
              {{ charity.description }}
            </td>
          </tr>
        </table>
        <hr>
      </div>
      <div
        class="Notice Notice--info pointer"
        @click="selectAmazonVoucher()"
      >
        <button
          id="claimed_voucher_code"
          class="Button Button--primary"
        >
          Claim your &pound;5 Amazon voucher
        </button>
      </div>
    </div>

    <div v-show="incentive.result == 'incorrect-link'">
      <div class="Notice Notice--warning">
        <h1 class="Notice-header">
          Sorry!
        </h1>
        <p class="Notice-Copy">
          It appears you are using an incorrect link to try and claim your voucher.
        </p>
      </div>
    </div>

    <div v-show="incentive.result == 'incentive-not-eligible'">
      <div class="Notice Notice--warning">
        <h1 class="Notice-header">
          Review Voucher Code
        </h1>
        <p class="Notice-Copy">
          Sorry, this review is not eligible for a voucher at this time.
        </p>
      </div>
    </div>

    <div v-show="incentive.result == 'incentive-unavailable'">
      <div class="Notice Notice--warning">
        <h1 class="Notice-header">
          Sorry!
        </h1>
        <p class="Notice-Copy">
          {{ incentive.message }}
        </p>
      </div>
    </div>

    <div v-show="incentive.result == 'incentive-claimed'">
      <h1>You have already claimed or donated your &pound;5 voucher</h1>
      <p>It appears that you’ve already claimed or donated your &pound;5 voucher.</p>
      <p>
        If you are looking for your Amazon voucher code please
        <a href="/dashboard/my-reviews"> log-in to your account</a>.
      </p>
    </div>

    <div v-if="incentive.result == 'voucher-redeemed'">
      <p>{{ incentive.message }}</p>
      <div class="Notice Notice--info">
        <b id="claimed_voucher_code">{{ incentive.value }}</b>
      </div>
      <p>You can also view this code at any time from your RateMyPlacement account once you have signed in.</p>
    </div>

    <div v-if="incentive.result == 'charity-redeemed'">
      <h2>Thank you for donating!</h2>
      <div class="Notice Notice--info">
        <b id="claimed_voucher_code">{{ incentive.message }}</b>
      </div>
    </div>

    <div v-show="ui.loaded">
      <hr>
      <a
        href="/dashboard/my-reviews/"
        class="Button Button--orange"
      >
        <span>View Your Account</span>
      </a>
    </div>

    <base-modal
      v-model="ui.showModal"
      extra-classes="Center"
    >
      <template #modal-header>
        <h2>{{ modal.title }}</h2>
      </template>
      <template #modal-body>
        <div class="Notice Notice--warning">
          <p class="Notice-copy">
            {{ modal.copy }}
          </p>
        </div>
      </template>
      <template #modal-footer>
        <div
          class="ButtonGroup-item"
        >
          <button
            class="Button Button--grey"
            @click.prevent="ui.showModal = false"
          >
            Cancel
          </button>
        </div>
        <div class="ButtonGroup-item">
          <button
            v-if="modal.incentiveType === 'amazon'"
            :class="{ 'is-loading': ui.loadingState }"
            :disabled="ui.loadingState"
            class="Button Button--primary"
            @click.prevent="confirmIncentiveSelection"
          >
            Claim Amazon Voucher
          </button>
          <button
            v-if="modal.incentiveType === 'charity'"
            :class="{ 'is-loading': ui.loadingState }"
            :disabled="ui.loadingState"
            class="Button Button--primary"
            @click.prevent="confirmIncentiveSelection"
          >
            Donate
          </button>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '@/components/modal/base-modal';
import { axios } from '@/axios';

export default {
  components: {
    BaseModal,
  },

  props: {
    reviewId: {
      type: String,
      default: '',
    },
    hash: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      ui: {
        loaded: false,
        showModal: false,
      },
      incentive: {
        result: '',
        message: '',
        charities: [],
      },
      modal: {
        title: '',
        copy: '',
        incentiveType: '',
        selectedIncentive: {},
      },
    };
  },

  computed: {
    redeemTitle() {
      return (this.incentive.charities_count > 0)
        ? 'Claim or donate your &pound;5 Amazon voucher'
        : 'Claim Your &pound;5 Amazon Voucher';
    },
  },

  mounted() {
    this.getIncentives();
  },

  methods: {
    getIncentives() {
      this.ui.loaded = false;

      axios.get(`/show-incentives/${this.reviewId}/${this.hash}`)
        .then((response) => {
          this.incentive = response.data.data;

          this.ui.loaded = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectCharity(charity) {
      console.log('selectCharity');
      this.modal.title = `Donate to ${charity.incentive_type_name}`;
      this.modal.copy = 'Are you sure you want to donate your £5?';
      this.modal.incentiveType = 'charity';
      this.modal.selectedIncentive = charity;

      this.ui.showModal = true;
    },

    selectAmazonVoucher() {
      console.log('selectAmazonVoucher');
      this.modal.title = 'Claim Your Amazon Voucher';
      this.modal.copy = 'Are you sure you want to claim your £5 voucher?';
      this.modal.incentiveType = 'amazon';
      this.modal.selectedIncentive = {};

      this.ui.showModal = true;
    },

    confirmIncentiveSelection() {
      this.ui.loaded = false;

      const payload = {
        hash: this.hash,
        reviewId: this.reviewId,
        incentiveType: this.modal.incentiveType,
        incentive: this.modal.selectedIncentive,
      };

      axios.post('/save-incentive', payload)
        .then((response) => {
          console.log(response.data.data);
          this.ui.showModal = false;

          this.incentive = response.data.data;
          console.log(this.incentive);

          this.ui.loaded = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};

</script>

<style lang="scss" scoped>

hr {
    display: block;
    clear: both;
    border: none;
    height: 1px;
    margin: 1em auto;
    width: 100%;
    background-color: #FFF;
}

.pointer {cursor: pointer;}

</style>
